module.exports = __webpack_public_path__ + "img/DE01670.84a39e3a.png";